
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AddressToggleChip extends Vue {
  @Prop({ required: true }) value!: boolean;

  @Prop({ required: true }) label!: string;

  @Prop({ default: 'secondary' }) variant!: 'secondary' | 'primary';

  @Prop({ default: true }) dismissible!: boolean;

  @Prop({ default: 'sm' }) size!: 'sm' | 'lg';
}
